<template>
  <div class="f-slider">
    <v-row no-gutters>
      <v-col>
        <v-range-slider
          hide-details
          thumb-color="primary"
          track-color="gray"
          :min="min"
          :max="max"
          :step="step"
          v-model="value"
          @end="apply()"
          @click="apply()"
        ></v-range-slider>
      </v-col>
    </v-row>
    <v-row class="pt-1">
      <v-col class="">
        <v-text-field
          type="Number"
          :min="min"
          :max="value[1]"
          :value="value[0]"
          outlined
          label="From"
          dense
          hide-details
          @change="
            $set(value, 0, $event);
            apply();
          "
        ></v-text-field>
      </v-col>
      <!-- <v-col cols="1 pt-5 text-center">to</v-col> -->
      <v-col class="pl-1">
        <v-text-field
          type="Number"
          :min="value[0]"
          :max="max"
          :value="value[1]"
          outlined
          label="To"
          dense
          hide-details
          @change="
            $set(value, 1, $event);
            apply();
          "
        ></v-text-field>
      </v-col>
      <!-- <v-col cols="12" class="text-center">
        <v-btn-toggle dense color="primary">
          <v-btn outlined @click="setValue(low)"> Low </v-btn>
          <v-btn outlined @click="setValue(med)"> Mid </v-btn>
          <v-btn outlined @click="setValue(high)"> High </v-btn>
        </v-btn-toggle>
      </v-col> -->
    </v-row>
  </div>
</template>

<style>
.f-slider .v-slider--horizontal .v-slider__track-container {
  height: 4px !important;
}
</style>

<script>
export default {
  name: "Slider",
  props: {
    og: { type: Object, required: true },
    reload: { type: Boolean}
  },
  data() {
    return {
      min: 0,
      max: 0,
      step: 0.01,
      /*low: [],
      med: [],
      high: [],*/
      selectedMin: 0,
      selectedMax: 0,
      value: [0, 0],
    };
  },
  methods: {
    init() {
      this.min = this.og.slider.min;
      this.max = this.og.slider.max;
      this.value = [this.og.slider.selectedMin, this.og.slider.selectedMax];
      // this.formLowMedHigh();
    },
    apply() {
      this.og.slider.selectedMin = Number(this.value[0]);
      this.og.slider.selectedMax = Number(this.value[1]);
      this.og.slider.selected = true;
      // this.og.showClearOption = this.enableClear;
      this.$emit("applyFilter", {
        id: this.og.refId,
        // action: cb.selected? "add":"remove",
        // val: cb.value,
      });
    },
    /*setValue(val) {
      this.value = val;
      this.apply();
    },
    formLowMedHigh() {
      let slider = this.og.slider
      let v = (slider.max-slider.min)/3;
      this.low = [slider.min, slider.min+v];
      this.med = [slider.min+v, slider.min+(2*v)];
      this.high = [slider.min+(2*v), slider.max];
      console.log({low:this.low,med:this.med,hight:this.high})
    }*/
  },
  watch: {
    reload (n) {
      if (n) {
        this.init();
      }
    },
  },
  computed: {
    // enableClear() {
    //   return (
    //     this.value[0] !== this.og.slider.min ||
    //     this.value[1] !== this.og.slider.max
    //   );
    // },
  },
  created() {
    this.init();
  },
};
</script>
